module.exports = __webpack_public_path__ + "static/media/plus-green.89a51700.svg";